import { render, staticRenderFns } from "./closedInvoiceTrash.vue?vue&type=template&id=041f8310&scoped=true&"
import script from "./closedInvoiceTrash.vue?vue&type=script&lang=js&"
export * from "./closedInvoiceTrash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041f8310",
  null
  
)

export default component.exports